import wixApplication from 'wix-application';
import wixLocation from 'wix-location';
import wixWindowFrontend from 'wix-window-frontend';
import { combineArraysToObject } from 'public/utils.js';
let plan, viewPort, instance;

$w.onReady(async function () {
    $w('#textUpgrade').delete();
    instance = await wixApplication.getDecodedAppInstance();
    plan = instance.vendorProductId;
    viewPort = wixWindowFrontend.formFactor;
    if (!plan) {
        $w('#textUpgrade').expand();
        $w('#textUpgrade').restore();
        $w('#textUpgrade').show('fade', { delay: 1000, duration: 500 })
    } else {
        $w('#textUpgrade').hide();
        $w('#textUpgrade').collapse();
        $w('#textUpgrade').delete();
    }
    init();
});

$widget.onPropsChanged((oldProps, newProps) => {
    init();
});

function init() {
    let props = {
        playerProps: JSON.parse(JSON.stringify($widget.props))
    }

    props.playerProps.widget_referrer = wixLocation.url;
    props.playerProps.origin = wixLocation.baseUrl;
    props.arrow = combineArraysToObject('arrow', $widget.props.s_arrow);
    props.paging = combineArraysToObject('paging', $widget.props.s_paging);
    if (viewPort === "Mobile") {
        props.sliderProps = combineArraysToObject("m_sliderProps", $widget.props.m_sliderProps);
    } else {
        props.sliderProps = combineArraysToObject("sliderProps", $widget.props.sliderProps);
    }
    if (!plan) {
        props.wm = true;
    }

    $w('#youtubeElementSlider').setAttribute('settings', JSON.stringify(props));
}
